import type { IconDefinition } from '../index.tsx';

export const iconLightningBolt: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconLightningBolt',
  icon: [16, 16, [], '', 'M9 7L10 0H8L2 7V9H7L6 16H8L14 9L14 7H9Z'],
};
